import React, { Component } from 'react';
import styled from 'styled-components/macro';
import scaleSize from '../../utils/scale-size';
import { Focusable } from '../navigation';
import config from '../../config';

const GRID_ITEM_WIDTH = 355;

const StyledGridItem = styled(Focusable)`
width: ${scaleSize(GRID_ITEM_WIDTH)}px;
  display: inline-block;
  text-align: center;
  margin-right: ${scaleSize(20)}px;
  margin-bottom: ${scaleSize(70)}px;
  box-sizing: border-box;
  cursor: pointer;
  
   &:hover {
    & > div {
      transform: translate3d(0, -${scaleSize(10)}px, 0);
    }
  }

  &:focus {
    & > div {
      transform: translate3d(0, -${scaleSize(20)}px, 0);
      border: solid ${scaleSize(8)}px ${({ theme }) => theme.activeColor};
    }

    & > span {
      font-size: ${scaleSize(46)}px;
      transform: translate3d(0, -${scaleSize(15)}px, 0);
      color: ${({ theme }) => theme.activeColor};
    }

    & > i {
      color: ${({ theme }) => theme.activeColor};
    }
`;

const GridItemCover = styled.div`
  width: ${scaleSize(GRID_ITEM_WIDTH)}px;
  height: ${scaleSize(355)}px;
  border: solid ${scaleSize(8)}px transparent;
  box-sizing: border-box;
  background: ${({ theme }) => theme.imagePlaceholder};
  transform: translate3d(0, 0, 0);
  transition: ${config.withAnimation ? 'transform 0.2s' : 'none'};
`;

const GridItemTitle = styled.span`
  font-size: ${scaleSize(34)}px;
  line-height: ${scaleSize(34)}px;
  height: ${scaleSize(34)}px;
  margin-top: ${scaleSize(20)}px;
  margin-bottom: ${scaleSize(5)}px;
  color: ${({ theme }) => theme.mainTextColor};
  transform: translate3d(0, 0, 0);
  transition: ${config.withAnimation ? 'transform 0.2s' : 'none'};
  font-family: RobotoCondensedBold, sans-serif;
  display: block;
`;

const GridItemMetadata = styled.i`
  font-size: ${scaleSize(24)}px;
  line-height: ${scaleSize(28)}px;
  color: ${({ theme }) => theme.secondaryTextColor};
  font-style: normal;
  display: block;
`;

class GridItem extends Component {
  onFocus = () => {
    const { onFocus, item, itemIndex } = this.props;

    onFocus && onFocus(item, itemIndex);
  };
  render() {
    const { id, item } = this.props;

    return (
      <StyledGridItem id={id} onFocus={this.onFocus}>
        <GridItemCover />
        <GridItemTitle>{item.title}</GridItemTitle>
        <GridItemMetadata>
          {item.time} / {item.channel}
        </GridItemMetadata>
      </StyledGridItem>
    );
  }
}

export default GridItem;
